import { render, staticRenderFns } from "./EtabGoogleActu.vue?vue&type=template&id=30e655a4"
import script from "./EtabGoogleActu.vue?vue&type=script&lang=js"
export * from "./EtabGoogleActu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports